import * as actions from './actions';

import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { AjaxResponse } from 'rxjs/ajax';
import { Epic } from 'redux-observable';
import { GetResourceTimeRangesAPIResponse } from './types';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';
import { transformErrorIntoSerializableError } from 'store/utils';
import { ResourceBookingServiceClient } from 'store/api-client/resource-booking-service-client';
import { ENABLE_RESOURCE_BOOKING_SERVICE } from 'store/featureFlags/consts';
import { ResourceBookingEnum } from 'store/app-instance-configs/enums';

export const getResourceTimeRangesEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(actions.getResourceTimeRanges.request)),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) => {
      const useService = state.featureFlags?.flags?.[ENABLE_RESOURCE_BOOKING_SERVICE];
      const resourceUuid = state.resource?.resource?.uuid;
      const currentConfig = state.appInstanceConfigs?.app_instance_configs?.find(
        config => config.uuid === state.appInstanceConfigs.currentAppInstanceConfigUuid,
      );
      const isNativeAdapter = currentConfig?.vertical_adapter?.name === ResourceBookingEnum.NativeAdapter;

      if (useService && isNativeAdapter && resourceUuid) {
        const serviceClient = new ResourceBookingServiceClient(state.config.apiUrl, state.config.authToken);

        return serviceClient.getResourceTimeRanges(resourceUuid, payload).pipe(
          map(({ data }) =>
            actions.getResourceTimeRanges.success({
              time_ranges: data.time_ranges,
              preset_bookable_windows: data.preset_bookable_windows,
            }),
          ),
          catchError((error: Error) =>
            of(actions.getResourceTimeRanges.failure({ error: transformErrorIntoSerializableError(error) })),
          ),
        );
      }

      return apiClient(state)
        .getResourceTimeRanges(payload)
        .pipe(
          map(({ response }: AjaxResponse<GetResourceTimeRangesAPIResponse>) => {
            return actions.getResourceTimeRanges.success({
              time_ranges: response.data.time_ranges,
              preset_bookable_windows: response.data.preset_bookable_windows,
            });
          }),
          catchError((error: Error) =>
            of(actions.getResourceTimeRanges.failure({ error: transformErrorIntoSerializableError(error) })),
          ),
        );
    }),
  );
